import types from "./types";

const showFooter = () => {
  return {
    type: types.SHOW_FOOTER,
  };
};

const hideFooter = () => {
  return {
    type: types.HIDE_FOOTER,
  };
};

const expandFooter = () => {
  return {
    type: types.EXPAND_FOOTER,
  };
};

const collapseFooter = () => {
  return {
    type: types.COLLAPSE_FOOTER,
  };
};

export default {
  showFooter,
  hideFooter,
  expandFooter,
  collapseFooter,
};



// WEBPACK FOOTER //
// ./src/redux/magnetFooter/actions.js